<template>
  <article>
    <div class="flex items-center px-4 py-4 sm:px-6">
      <div class="min-w-0 flex-1 flex items-center">
        <div class="flex-shrink-0">
          <span class="inline-block overflow-hidden bg-gray-100 h-12 w-12">
            <ProfileIconSvg class="h-12 w-12 rounded-md" />
          </span>
        </div>
        <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
          <div>
            <p>
              <span class="text-sm font-medium truncate text-teal-600">
                Einladung vom {{ $d(invitation.created_at, 'short') }}
              </span>
              <span v-if="expired" class="status ml-2">
                Abgelaufen!
              </span>
            </p>
            <p class="mt-2 flex items-center text-sm text-gray-500">
              <EnvelopeIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span class="truncate">
                {{ invitation.email }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div>
        <ActionButton @click="resend" :disabled="success">
          Nochmal senden
        </ActionButton>
      </div>
    </div>
  </article>
</template>

<script setup>
import { ref, computed } from 'vue';
import client from '@/client/index';

const props = defineProps({invitation: Object});

const model = computed(() => props.invitation);
const expired = computed(() => model.value.expired);

const target = computed(() => '/api/invitations/' + model.value.id);
const success = ref(false);

const resend = () =>
{
  client.post(target.value + ':resend')
  .then(result => success.value = true)
  .catch(error => success.value = false);
};
</script>

<style scoped>
.status
{
  @apply inline-flex items-center;
  @apply px-2.5 py-0.5 rounded-full;
  @apply text-xs font-medium capitalize;
  @apply bg-red-100 text-red-800;
};
</style>